import Cookies from 'js-cookie';
import { jsonUrl } from './url_utils';
import param from './param';

export function rejectOnNotOk(r: Response): Promise<Response> {
  if (r.ok) {
    return Promise.resolve(r);
  } else {
    return Promise.reject(r);
  }
}

export async function post(url: string, body?: unknown) {
  // we should consider saving this
  const csrfToken = await getCsrfToken();
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    credentials: 'same-origin',
    body: JSON.stringify(body),
  })
    .then(rejectOnNotOk)
    .then((r) => r.json());
}

export async function put(url: string, body?: unknown) {
  const csrfToken = await getCsrfToken();
  return fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    credentials: 'same-origin',
    body: JSON.stringify(body),
  })
    .then(rejectOnNotOk)
    .then((r) => r.json());
}

export function get(url: string, params?: object) {
  if (params !== undefined) {
    const paramString = param(params);
    if (paramString) {
      if (url.includes('?')) {
        url += '&' + paramString;
      } else {
        url += '?' + paramString;
      }
    }
  }
  url = jsonUrl(url);
  return fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
    .then(rejectOnNotOk)
    .then((r) => r.json());
}

export function patch(url: string, body: unknown) {
  return getCsrfToken()
    .then((csrfToken) =>
      fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        credentials: 'same-origin',
        body: JSON.stringify(body),
      }),
    )
    .then((r) => (r.ok ? r.json() : Promise.reject(r)));
}

// delete is a keyword, unforch.
export function deleteRequest(url: string) {
  return getCsrfToken().then((csrfToken) =>
    fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
    }),
  );
}

// making this async is maybe premature, but on some pages `csrf-token` isn't immediately present
function getCsrfToken(): Promise<string> {
  return new Promise((r) => {
    const result =
      document.querySelector<HTMLMetaElement>("[name='csrf-token']")?.content ??
      Cookies.get('masked_csrf_token');
    if (result) {
      r(result);
    }
  });
}
